import { Language } from './types';

const BASE_INVOICE_LABELS = {
  MOVEMENTS: 'Movements',
  PAYMENT_REQUEST: 'Payment request',
  COLLECT_LOCAL_PAYMENT: 'Collect Payins in Local Currency',
  rvlOriginAmount: 'Origin amount',
  rvlPaymentDue: 'Payment due',
  rvlAmount: 'Amount',
  rvlAmountToReceive: 'Amount to receive',
  rvlDate: 'Date',
  rvlDateRequested: 'Date requested',
  rvlDetail: 'Detail',
  rvlName: 'Client name',
  rvlStatus: 'Status',
};

type LabelsLanguage = keyof typeof BASE_INVOICE_LABELS;

const RECEIVABLES_VIEW_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_INVOICE_LABELS,
  ES: {
    MOVEMENTS: 'Movimientos',
    PAYMENT_REQUEST: 'Solicitud de pago',
    COLLECT_LOCAL_PAYMENT: 'Cobranza en moneda local',
    rvlOriginAmount: 'Monto original',
    rvlPaymentDue: 'Vencimiento',
    rvlAmount: 'Monto',
    rvlAmountToReceive: 'Monto a recibir',
    rvlDate: 'Fecha',
    rvlDateRequested: 'Fecha solicitada',
    rvlDetail: 'Detalle',
    rvlName: 'Nombre del cliente',
    rvlStatus: 'Estado',
  },
};

export default RECEIVABLES_VIEW_LABELS;
